import {
  useGetSaveSubjectiveQLQuery,
  useGetUploadConfigQuery
} from "@assessment/store/slices/api/assessmentApiSlice";
import { useAppDispatch, useAppSelector } from "@assessment/store/store";
import RichTextEditor from "@lxp-app/components/molecules/rich-text-editor/richTextEditor";
import React, { useEffect, useState } from "react";
import AudioResponse from "./audioResponse";
import VideoResponse from "./videoResponse";
import { SubjectiveActions } from "@assessment/store/slices/subjectiveSlice";
import TextResponse from "./textResponse";

interface Subjective {
  question: any;
  sectionId: string;
}

const SubjectiveAnswerSubmission = ({ question, sectionId }: Subjective) => {
  const dispatch = useAppDispatch();

  const [text, setText] = useState<string>("");

  const ongoingId = useAppSelector((store) => store.AssessmentSlice.ongoingId);

  const {
    data: savedAnswers,
    isLoading,
    refetch: refetchSavedAnswers
  } = useGetSaveSubjectiveQLQuery(
    {
      ongoingId: ongoingId,
      questionId: question?.questionId,
      questionVersion: question?.versionnumber
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  const { data: uploadConfigData } = useGetUploadConfigQuery({
    questionId: question?.questionId!,
    quesVersion: question?.versionnumber!
  });
  const subType = question?.submissionType?.[0];

  useEffect(() => {
    if (uploadConfigData?.data)
      dispatch(SubjectiveActions.mutateUploadConfig(uploadConfigData?.data));
  }, [uploadConfigData?.data, question?.questionId]);

  useEffect(() => {
    if (savedAnswers?.getSaveSubjectiveQL?.data?.savedSubjective?.length > 0) {
      const savedTxt: string =
        savedAnswers?.getSaveSubjectiveQL?.data?.savedSubjective?.[0]
          ?.usersubmission;
      setText(savedTxt);
    } else setText("");
  }, [savedAnswers]);

  return (
    <div className="h-full min-h-0 w-full overflow-y-hidden">
      {subType === "text" && (
        <TextResponse
          sectionId={sectionId}
          question={question}
          uploadConfig={uploadConfigData?.data}
          latestSubmissionId={
            savedAnswers?.getSaveSubjectiveQL?.data?.latestSubmissionId
          }
          refetchSavedAnswers={refetchSavedAnswers}
        />
      )}
      {subType === "video" && (
        <VideoResponse
          sectionId={sectionId}
          question={question}
          uploadConfig={uploadConfigData?.data}
        />
      )}
    </div>
  );
};

export default SubjectiveAnswerSubmission;
